import Vue from 'vue'
import App from './App'
import router from './router'
import {
  Menu,
  MenuItem,
  Submenu,
  MenuItemGroup,
  Container,
  Aside,
  Scrollbar,
  Main,
  Breadcrumb,
  BreadcrumbItem,
  Carousel,
  CarouselItem,
  Tabs,
  TabPane,
  Image,
  Option,
  Pagination,
  Select,
  TableColumn,
  Button,
  Table
} from 'element-ui'
import 'babel-polyfill'
import i18n from './assets/js/lang'
import store from './store'
import './assets/js/cookie'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/reset.css'
import './assets/css/common.css'
import 'swiper/dist/css/swiper.css'
// import './assets/css/markdown_default.css'
// import './assets/css/markdown_hljs.min.css'
// import './assets/css/markdown_bd.css'
import './assets/css/markdown_self.css'
// 新版官网全局样式（须最后引入，内含 reset.css 兼容层）
import './assets/css/supertech.css'
import  { downloadUrl, appUrl, pcUrl, superCloudUrl, pcOfficialUrl } from './assets/js/url'
import cjyTable from './plugin/index';
Vue.use(cjyTable);
Vue.config.productionTip = false

Vue.prototype.$downloadUrl = downloadUrl
Vue.prototype.$hostPcUrl = pcUrl
Vue.prototype.$hostAppUrl = appUrl
Vue.prototype.$hostSuperCloudUrl = superCloudUrl
Vue.prototype.$hostPcOfficialUrl = pcOfficialUrl

Vue.use(Pagination);
Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(Submenu)
Vue.use(MenuItemGroup)
Vue.use(Container)
Vue.use(Aside)
Vue.use(Scrollbar)
Vue.use(Main)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Image)
Vue.use(Option)
Vue.use(Select)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Button)

// Vue.use(VueAwesomeSwiper, /* { default global options } */)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js